import { ContactForm } from "./ContactForm";

/**
 * The last step before the price appears.
 *
 * The copy above the form matters as much as the form: it tells the customer
 * exactly what happens when they press submit, so the gate never reads as
 * something being withheld from them.
 */
export const ContactGateStep = ({ busy, serverErrors, onSubmit }) => (
  <div>
    <div className="mb-5 rounded-lg border border-[color:var(--tt-teal-line)] bg-[color:var(--tt-teal-mist)] px-4 py-3.5">
      <p className="text-sm font-semibold text-[color:var(--tt-teal-deep)]">
        Your answers are in — we just need to know who we're quoting.
      </p>
      <p className="mt-1 text-[13px] leading-relaxed text-[color:var(--tt-teal-deep)]">
        As soon as you submit this, your price appears on screen and your PDF quote is ready to
        download. We're not hiding anything from you — we just want to know who to follow up
        with.
      </p>
    </div>
    <ContactForm
      variant="gate"
      idPrefix="contact"
      busy={busy}
      serverErrors={serverErrors}
      onSubmit={onSubmit}
    />
  </div>
);
